export default __webpack_public_path__ + "static/media/asistencia-contribuyente.ade5c48d.svg";